export default __webpack_public_path__ + "static/media/sign-img.bec85d4f.png";